<template>
  <div>
    <div>
      <vue-good-table
          class="mx-4"
          :columns="columns"
          :rows="superBoms"
          :line-numbers="true"
          :group-options="{
          enabled: false,
          headerPosition: 'top'
        }">
        <div slot="emptystate">There are no entries</div>
        <div slot="table-actions">
          <AddSuperBom></AddSuperBom>
        </div>
        >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'action'">
            <router-link :to="{name:'SuperBom', params: { superBomId: props.row['id']}}">
              <md-button class="md-icon-button md-dense md-primary">
                <md-icon>mode_edit</md-icon>
              </md-button>
            </router-link>
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import 'vue-good-table/dist/vue-good-table.css';
import {VueGoodTable} from 'vue-good-table';
import AddSuperBom from './AddSuperBom'
import DeleteSuperBom from './DeleteSuperBom'

export default {
  name: 'SuperBomList',
  components: {
    VueGoodTable,
    AddSuperBom,
    DeleteSuperBom,
  },
  computed: mapGetters(['superBoms']),
  methods: {
    ...mapActions(['fetchSuperBoms']),
    deleteSuperBom(superbomId) {
      this.$store.dispatch('actionDeleteSuperBom', superbomId)
    },
  },
  async mounted() {
    this.fetchSuperBoms();
  },
  data() {
    return {
      columns: [
        {
          label: 'NIDme',
          field: 'id',
          type: 'number',
        },
        {
          label: 'Name',
          field: 'version',
          type: 'text',
          tdClass: 'resizeFont'
        },
        {
          label: 'Lot Size',
          field: 'lot_size',
          type: 'number',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.superBom {
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 1rem;
}
</style>
